import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    constructor() {
        super();

        this.setState({ valid: true });
    }

    render(props) {
        return (
            <input-validation>
                <input
                  {...props}
                  onBlur={this.validate}
                  onFocus={this.clear}
                  class={this.state.valid ? 'valid' : 'error'}
                />
            </input-validation>
        );
    }

    validate = (e) => {
        this.setState({ valid: e.target.checkValidity() });
    }

    clear = () => {
        this.setState({ valid: true });
    }
}

export default connect()(Component);



// WEBPACK FOOTER //
// ./app/components/form/input-validation.js